import { Search, Plus } from 'lucide-react';
import { OrbitIcon } from "@/components/icons/OrbitIcon";
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { InquiryStatus } from '@/types/crm';

interface SearchFiltersProps {
  searchQuery: string;
  onSearchChange: (query: string) => void;
  statusFilter: InquiryStatus | 'all';
  onStatusFilterChange: (status: InquiryStatus | 'all') => void;
  onManualEntry: () => void;
  /** POL-16 — Export CSV button removed; prop kept optional so the
      legacy Index.tsx call site still compiles. */
  onExportCSV?: () => void;
}

export const SearchFilters = ({
  searchQuery,
  onSearchChange,
  statusFilter,
  onStatusFilterChange,
  onManualEntry,
}: SearchFiltersProps) => {
  return (
    <div className="flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
      <div className="flex flex-col sm:flex-row gap-3 flex-1">
        <div className="relative flex-1 max-w-md">
          <OrbitIcon name="magnifyingglass" fallback={Search} className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-muted-foreground" />
          <Input
            placeholder="Search a name or email…"
            value={searchQuery}
            onChange={(e) => onSearchChange(e.target.value)}
            className="pl-10 bg-secondary border-border focus:border-primary"
          />
        </div>
        
        <Select value={statusFilter} onValueChange={(value) => onStatusFilterChange(value as InquiryStatus | 'all')}>
          {/* Full-width on mobile so the dropdown trigger isn't a
              cramped 180px chip jammed against the search input;
              fixed 180px on desktop where the search input takes
              the rest of the row. */}
          <SelectTrigger className="w-full sm:w-[180px] bg-secondary border-border">
            <SelectValue placeholder="Filter by status" />
          </SelectTrigger>
          <SelectContent className="bg-card border-border">
            <SelectItem value="all">All Statuses</SelectItem>
            <SelectItem value="pending">Pending</SelectItem>
            <SelectItem value="accepted">Accepted</SelectItem>
            <SelectItem value="in_progress">In Progress</SelectItem>
            <SelectItem value="follow_up">Follow Up</SelectItem>
            <SelectItem value="completed">Completed</SelectItem>
            <SelectItem value="closed_lost">Closed Lost</SelectItem>
          </SelectContent>
        </Select>
      </div>

      <div className="flex gap-3">
        <Button
          onClick={onManualEntry}
          className="bg-accent hover:bg-accent/90 text-accent-foreground"
        >
          <OrbitIcon name="plus" fallback={Plus} className="w-4 h-4 mr-2" />
          Add lead
        </Button>
      </div>
    </div>
  );
};
